import { previous_date } from "../components/Functions";

export const InitialCatalog = {
    asset_series: null,
    asset_summ: null,
    asset_tks_list: [],
    ref_curr: "USD",
    asset_series_per: "1M",
    asset_series_range: "10Y",
    asset_name:null,
    show_indices:true,
    show_products:true,
    errMess:null,
    end_date:(new Date()).toISOString().slice(0,10),
    initial_date:"2025-01-01",
    activate_initial_date:false,
    corr_matrix:null,
    sort_by: null,
    series_range:"MTD",
    cols_metrics:[
        {name:"Id", active:true, to_perc:false, to_fixed:false, cell_width:"150px"}, 
        {name:"Isin/Ticker", active:true, to_perc:false, to_fixed:false, cell_width:"120px"},
        {name:"Clase", active:true, to_perc:false, to_fixed:false, cell_width:"120px"},
        {name:"Moneda", active:true, to_perc:false, to_fixed:false, cell_width:"80px"},
        {name:"Retorno Total", active:true, to_perc:true, to_fixed:false, cell_width:"80px"}, 
        {name:"Retorno Promedio Anual.", active:true, to_perc:true, to_fixed:false, cell_width:"80px"},
        {name:"Retorno Periodo Anual.", active:true, to_perc:true, to_fixed:false, cell_width:"80px"},
        {name:"Volatilidad Anual.", active:true, to_perc:true, to_fixed:false, cell_width:"80px"},
        {name:"Drawdown", active:true, to_perc:true, to_fixed:false, cell_width:"80px"},
        {name:"DDT (días)", active:true, to_perc:false, to_fixed:false, cell_width:"80px"}, 
        {name:"TTR (días)", active:true, to_perc:false, to_fixed:false, cell_width:"80px"},
        {name:"Sharpe", active:true, to_perc:false, to_fixed:true, cell_width:"80px"},
        {name:"Negativos", active:true, to_perc:false, to_fixed:true, cell_width:"80px"}
        ]
};

export const InitialParams = {
    ref_curr:"USD",
    date_ref:(new Date()).toISOString().slice(0,10),
    date_ini:"2014-01-01",
    optim_type:"absolute",
    bench_name:"",
    ref_port_assets:null,
    max_dev:"",
    risk_metric:"vol",
    ret_metric:"mean",
    rets_per:"monthly",
    min_ret:"",
    max_risk:"",
    target_dur:"",
    dur_interv:2,
    fx_exp_rate:"",
    fx_hist_rate:true,
    auto_reg_param:false,
    reg_param:0,
    views_saa:false,
    random_views:false,
    msg:null,
    edit_tables:false,
    optim_strategy:"cv",
    robust_sol:false,
    frontier_ind:false,
    min_exp_per_asset:null,
    max_exp_per_asset:null,
    shrink_covar:true,
    job_id:null,
    job_status:null
};

export const InitialClientParams = {
    port_name:null,
    bench_name:null,
    fx:"USD",
    risk_type:'ex_ante',
    risk_type_suit:'ex_ante',
    assets_bench:false,
    port_date:(new Date()).toISOString().slice(0,10),
    perf_date:(new Date()).toISOString().slice(0,10),
    ini_date:previous_date("1M", new Date()),
    metrics_date:"2015-01-01",
    perf_level:"rentabilidad_producto",
    perf_fields:"rentabilidad_producto",
    perf_select_fields:false,
    perf_ccy:"CLP",
    activate_initial_date:false,
    period:"MTD",
    flows:null,
    show_detail:false,
    show_detail_grouped:false,
    show_flows:false,
    ignore_cash_exposure:false,
    cash_fx_return:true,
    use_return_proxy:true,
    perf_method:"ME",
    perf_variables:[
        {name:"level", label:"Nivel", to_perc:false, to_money:false, width:"90px", grouper:false, include:false}, // clientId is included by default
        {name:"clientId", label:"Id Cliente", to_perc:false, to_money:false, width:"90px", grouper:false, include:true}, // clientId is included by default
        {name:"marketScope", label:"Local - Inter", to_perc:false, to_money:false, width:"90px", grouper:true, include:true},
        {name:"contribType", label:"Regimen", to_perc:false, to_money:false, width:"90px", grouper:true, include:true},
        {name:"regimeAccountType", label:"Tipo Cuenta", to_perc:false, to_money:false, width:"90px", grouper:true, include:true},
        {name:"entity", label:"Entidad", to_perc:false, to_money:false, width:"90px", grouper:true, include:true},
        {name:"assetType", label:"Tipo Activo", to_perc:false, to_money:false, width:"90px", grouper:true, include:true},
        {name:"assetId", label:"Id Activo", to_perc:false, to_money:false, width:"90px", grouper:true, include:true},
        {name:"serie", label:"Serie", to_perc:false, to_money:false, width:"60px", grouper:true, include:true},
        {name:"currency", label:"Moneda", to_perc:false, to_money:false, width:"60px", grouper:true, include:false},
        {name:"dateIni", label:"Fecha Inicial", to_perc:false, to_money:false, width:"60px", grouper:true, include:false},
        {name:"dateLast", label:"Fecha Final", to_perc:false, to_money:false, width:"60px", grouper:true, include:false},
        {name:"aumIni", label:"Saldo Inicial", to_perc:false, to_money:true, width:"100px", grouper:false, include:true},
        {name:"aumLast", label:"Saldo Final", to_perc:false, to_money:true, width:"100px", grouper:false, include:true},
        {name:"cfExternal", label:"Flujo Neto Externo", to_perc:false, to_money:true, width:"95px", grouper:false, include:false},
        {name:"cfNetProxy", label:"Flujo Neto Aprox.", to_perc:false, to_money:true, width:"95px", grouper:false, include:false},
        {name:"cfNet", label:"Flujo Neto", to_perc:false, to_money:true, width:"95px", grouper:false, include:true},
        {name:"cfSum", label:"Aporte", to_perc:false, to_money:true, width:"100px", grouper:false, include:true},
        {name:"cfSub", label:"Rescate", to_perc:false, to_money:true, width:"100px", grouper:false, include:true},
        {name:"capitalGain", label:"Ganancia Capital", to_perc:false, to_money:true, width:"90px", grouper:false, include:false},
        {name:"dividends", label:"Dividendos", to_perc:false, to_money:true, width:"90px", grouper:false, include:false},
        {name:"profit", label:"Utilidad", to_perc:false, to_money:true, width:"95px", grouper:false, include:true},
        {name:"commission", label:"Comisión", to_perc:false, to_money:true, width:"90px", grouper:false, include:false},
        {name:"return", label:"Retorno", to_perc:true, to_money:false, width:"70px", grouper:false, include:true},
        {name:"contrib", label:"Contribución", to_perc:true, to_money:false, width:"70px", grouper:false, include:true}
    ],
    perf_detail_variables:[
        {name:"marketScope",    label:"Local - Inter",    to_perc:false, to_money:false, to_fixed:false, width:"90px", grouper:false, include:false},
        {name:"contribType",    label:"Regimen",          to_perc:false, to_money:false, to_fixed:false, width:"90px", grouper:false, include:false},
        {name:"regimeAccountType", label:"Tipo Cuenta",   to_perc:false, to_money:false, to_fixed:false, width:"90px", grouper:false, include:false},
        {name:"entity",         label:"Entidad",          to_perc:false, to_money:false, to_fixed:false, width:"90px", grouper:false, include:false},
        {name:"assetType",      label:"Tipo Activo",      to_perc:false, to_money:false, to_fixed:false, width:"90px", grouper:false, include:false},
        {name:"assetName",      label:"Nombre Activo",    to_perc:false, to_money:false, to_fixed:false, width:"100px", grouper:true,  include:true},
        {name:"assetId",        label:"Id Activo",           to_perc:false, to_money:false, to_fixed:false, width:"85px", grouper:true,  include:true},
        {name:"serie",          label:"Serie",           to_perc:false, to_money:false, to_fixed:false, width:"30px", grouper:false,  include:true},
        {name:"dateIni",        label:"Fecha Inicial",    to_perc:false, to_money:false, to_fixed:false, width:"70px", grouper:false, include:true},
        {name:"dateLast",       label:"Fecha Final",      to_perc:false, to_money:false, to_fixed:false, width:"70px", grouper:false, include:true},
        {name:"quantityIni",    label:"Cantidad Inicial",to_perc:false, to_money:false, to_fixed:true, width:"80px", grouper:false, include:true},
        {name:"quantityLast",   label:"Cantidad Final",  to_perc:false, to_money:false, to_fixed:true, width:"80px", grouper:false, include:true},
        {name:"quantityFlow",   label:"Cantidad Flujo",  to_perc:false, to_money:false, to_fixed:true, width:"80px", grouper:false, include:true},
        {name:"aumIni",         label:"AUM Inicial",     to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:true},
        {name:"aumLast",        label:"AUM Final",       to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:true},
        {name:"cfExternal",     label:"Flujo Externo",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"cfNet",          label:"Flujo Neto",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:true},
        {name:"cfNetProxy",     label:"Flujo Neto Aprox.",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"return",         label:"Retorno",         to_perc:true,  to_money:false, to_fixed:false, width:"60px", grouper:false, include:true},
        {name:"returnPrice",    label:"Retorno Precio",   to_perc:true,  to_money:false, to_fixed:false, width:"60px", grouper:false, include:true},
        {name:"returnEstimated",label:"Retorno Estimado",   to_perc:true,  to_money:false, to_fixed:false, width:"60px", grouper:false, include:true},
        {name:"status",         label:"Estado",          to_perc:false, to_money:false, to_fixed:false, width:"70px", grouper:false, include:true},
        {name:"clientId",       label:"Id Cliente", to_perc:false, to_money:false, width:"90px", grouper:false, include:false}, // clientId is included by default
        {name:"currency",       label:"Moneda", to_perc:false, to_money:false, width:"60px", grouper:true, include:false},
        {name:"referenceDate",  label:"Fecha",    to_perc:false, to_money:false, to_fixed:false, width:"70px", grouper:false, include:false},
        {name:"capitalGain",    label:"Ganancia Capital",        to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"dividends",      label:"Dividendos",        to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"profit",         label:"Utilidad",        to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:true},
        {name:"cfSum",          label:"Entradas",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"cfSub",          label:"Salidas",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"commission",     label:"Comisión",        to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"aumExp",         label:"AUM Exp.",     to_perc:false, to_money:true, to_fixed:false,  width:"95px", grouper:false, include:false},
        {name:"unnorm_ret",     label:"Retorno No-Norm.", to_perc:true, to_money:false, to_fixed:false, width:"70px", grouper:false, include:false},
        {name:"w_return",       label:"Retorno Pond.", to_perc:true, to_money:false, to_fixed:false, width:"70px", grouper:false, include:false},
        {name:"weight",         label:"Peso", to_perc:true, to_money:false, to_fixed:false, width:"70px", grouper:false, include:false}
    ],
    perf_detail_grouped_variables:[
        {name:"referenceDate", label:"Fecha", to_perc:false, to_money:false, width:"90px", include:true}, // clientId is included by default
        {name:"clientId", label:"Id Cliente", to_perc:false, to_money:false, width:"90px", include:false}, // clientId is included by default
        {name:"currency", label:"Moneda", to_perc:false, to_money:false, width:"60px", include:false},
        {name:"marketScope", label:"Local - Inter", to_perc:false, to_money:false, width:"90px", include:true},
        {name:"contribType", label:"Regimen", to_perc:false, to_money:false, width:"90px", include:true},
        {name:"regimeAccountType", label:"Tipo Cuenta", to_perc:false, to_money:false, width:"90px", include:true},
        {name:"entity", label:"Entidad", to_perc:false, to_money:false, width:"90px", include:true},
        {name:"assetType", label:"Tipo Activo", to_perc:false, to_money:false, width:"90px", include:true},
        {name:"assetId", label:"Id Activo", to_perc:false, to_money:false, width:"90px", include:true},
        {name:"serie", label:"Serie", to_perc:false, to_money:false, width:"60px", include:true},
        {name:"aumIni",         label:"AUM Inicial",     to_perc:false, to_money:true, to_fixed:false,  width:"100px", include:true},
        {name:"aumLast",        label:"AUM Final",       to_perc:false, to_money:true, to_fixed:false,  width:"100px", include:true},
        {name:"aumExp",         label:"AUM Exp.",     to_perc:false, to_money:true, to_fixed:false,  width:"100px", include:true},
        {name:"cfNet",          label:"Flujo Neto",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", include:true},
        {name:"cfSum",          label:"Entradas",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", include:true},
        {name:"cfSub",          label:"Salidas",      to_perc:false, to_money:true, to_fixed:false,  width:"95px", include:true},
        {name:"capitalGain",         label:"Ganancia Capital",        to_perc:false, to_money:true, to_fixed:false,  width:"95px",include:true},
        {name:"dividends",         label:"Dividendos",        to_perc:false, to_money:true, to_fixed:false,  width:"95px",include:true},
        {name:"profit",         label:"Utilidad",        to_perc:false, to_money:true, to_fixed:false,  width:"95px", include:true},
        {name:"commission",         label:"Comisión",        to_perc:false, to_money:true, to_fixed:false,  width:"95px",include:true},
        {name:"unnorm_ret", label:"Retorno", to_perc:true, to_money:false, to_fixed:false, width:"70px", include:true},
        {name:"w_return", label:"Retorno Pond.", to_perc:true, to_money:false, to_fixed:false, width:"70px", include:false},
        {name:"weight", label:"Peso", to_perc:true, to_money:false, to_fixed:false, width:"70px", include:false}
    ],
    flow_variables:[
        {name:"referenceDate",   label:"Fecha",              to_perc:false, to_money:false, to_fixed:false, width:"80px", include:true},
        {name:"marketScope",     label:"Local - Inter",      to_perc:false, to_money:false, to_fixed:false, width:"80px", include:false},
        {name:"contribType",     label:"Regimen",            to_perc:false, to_money:false, to_fixed:false, width:"80px", include:false},
        {name:"regimeAccountType", label:"Tipo Cuenta",      to_perc:false, to_money:false, to_fixed:false, width:"80px", include:false},
        {name:"entity",          label:"Entidad",            to_perc:false, to_money:false, to_fixed:false, width:"80px", include:false},
        {name:"assetType",       label:"Tipo Activo",        to_perc:false, to_money:false, to_fixed:false, width:"80px", include:false},
        {name:"assetId",         label:"Id Activo",          to_perc:false, to_money:false, to_fixed:false, width:"90px", include:true},
        {name:"serie",           label:"Serie",              to_perc:false, to_money:false, to_fixed:false, width:"40px", include:true},
        {name:"movType",         label:"Tipo Movimiento",    to_perc:false, to_money:false, to_fixed:false, width:"180px", include:true},
        {name:"regexFrCols",     label:"Campos compuestos",  to_perc:false, to_money:false, to_fixed:false, width:"180px", include:true},
        {name:"movType2",        label:"Tipo Movimiento2",   to_perc:false, to_money:false, to_fixed:false, width:"100px", include:true},
        {name:"movType2Auto",    label:"Tipo Mov. Auto",     to_perc:false, to_money:false, to_fixed:false, width:"100px", include:true},
        {name:"internalExternal",label:"Interno/Externo",    to_perc:false, to_money:false, to_fixed:false, width:"80px", include:true},
        {name:"mktValue",        label:"Valor Mercado",      to_perc:false, to_money:true, to_fixed:false, width:"100px", include:true},
        {name:"quantity",        label:"Cantidad",           to_perc:false, to_money:false, to_fixed:true, width:"80px", include:true},
        {name:"cf",              label:"Flujo Caja",         to_perc:false, to_money:true, to_fixed:false,  width:"100px", include:true},
        {name:"dividends",       label:"Dividendos",         to_perc:false, to_money:true, to_fixed:false,  width:"100px", include:false},
        {name:"simulated",       label:"Simul.",             to_perc:false, to_money:false, to_fixed:true, width:"50px", include:true},
    ]
};

export const InitialBacktestParams = {
    builder_ref_curr:"USD",
    ref_curr:"USD",
    ref_date:(new Date()).toISOString().slice(0,10),
    ini_date:"2015-01-01",
    range:"10Y",
    activate_initial_date:true,
    port_name: null,
    bench_name: null,
    rebal_dates_db: true,
    rebal_dates_db_bench: true,
    invest_assets: false,
    invest_assets_bench: false,
    per: 'monthly',
    rebal_period: 'quarterly',
    sync_rebal_dates: true,
    complete_rebal_dates_db: false,
    complete_tact: false,
    reset_weights: true,
    multiple_ports: false,
    ports:[],
    port_group:null,
    report_name:null,
    tac_ports:true,
    port_alloc_name:null,
    port_alloc_date:null
};

export const InitialBuilderParams = {
    ref_curr:"USD",
    asset_type:"funds",
    range:"10Y",
    msg:null
};

export const InitialComparParams = {
    ref_curr:"USD",
    ref_date:(new Date()).toISOString().slice(0,10),
    ini_date:"2014-01-01",
    port_names: [],
    invest_assets: false,
    returns_period: 'monthly',
    rebal_period: 'quarterly',
    return_assets:true,
    port_group:null,
    port_alloc_name:null,
    port_alloc_date:null
};

export const InitialTacticalParams = {
    port_name: null,
    ref_curr:"USD",
    ref_date:(new Date()).toISOString().slice(0,10),
    ini_date:"2014-01-01",
    rets_period: 'monthly',
    trades:[],
    port:null,
    funds:null,
    msg:null
};

export const InitialSignatureParams = {
    port_name: null,
    add_asset:null,
    ref_curr:"USD",
    range:"5Y",
    ref_date:(new Date()).toISOString().slice(0,10),
    ini_date:"2014-01-01",
    rets_period: 'monthly',
    port:null,
    initial_ac:null,
    asset_series:null,
    weights:null,
    trades:[],
    msg:null
};

export const InitialSuitParams = {
    table_name:null,
    table_id:null,
    table_data:[],
    run_id_value:"",
    filename:null,
    client_summ:null,
    client_suit_summ:null
};

export const InitialLoadParams = {
    saa_filename:null,
    client_filename:null
};

export const InitialFundParams = {
    funds_categ:'',
    funds_type:'',
    funds_range:'12M',
    funds_tks_list:[],
    funds_sel_date:(new Date()).toISOString().slice(0,10),
    use_etf:false
};

